// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
  production: true,
  //apiUrl: 'http://localhost:3000',
  
  //For Staging
  //apiUrl: 'http://64.136.239.133:8011',
 // QRCodeURL: 'https://gtrakweb-cust-staging.web.app/auth/login/scan-barcode',
  
  //FOr Production
   apiUrl: 'http://64.136.239.133:8010',
   QRCodeURL:'https://gtrakweb-customers.web.app/auth/login/scan-barcode', 

   //Google reCAPTCHA v2- Client side secret key
  siteKey:'6LdIVA4tAAAAANchuBoleBiEJDtRDD0ASI5p1vEm',
  enableFunctionsEmulator: false,
  firebase: {
    apiKey: "AIzaSyDVHTfNH1k0eml-KDgxI_BCEuYvW50IDCI",
    authDomain: "gtrakweb-63c8e.firebaseapp.com",
    projectId: "gtrakweb-63c8e",
    storageBucket: "gtrakweb-63c8e.firebasestorage.app",
    messagingSenderId: "60203959161",
    appId: "1:60203959161:web:1997082eb29b991fa625a8",
    measurementId: "G-9L0N04RJ62"
  },
  appShellConfig: {
    debug: false,
    networkDelay: 500
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
